function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2004 18.7999C36.5004 18.7999 35.9004 18.1999 35.9004 17.4999C35.9004 12.4999 33.9004 7.79994 30.4004 4.19995C29.9004 3.69995 29.9004 2.89995 30.4004 2.29995C30.9004 1.69995 31.7004 1.79995 32.3004 2.29995C36.3004 6.29995 38.6004 11.6999 38.6004 17.4999C38.5004 18.1999 37.9004 18.7999 37.2004 18.7999Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.3 18.8C0.6 18.8 0 18.2 0 17.5C0 11.8 2.2 6.40005 6.3 2.30005C6.8 1.80005 7.6 1.80005 8.2 2.30005C8.8 2.80005 8.7 3.60005 8.2 4.20005C4.6 7.80005 2.7 12.5 2.7 17.5C2.6 18.2 2 18.8 1.3 18.8Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3002 42C15.7002 42 12.7002 39.1 12.7002 35.4C12.7002 34.7 13.3002 34.1 14.0002 34.1C14.7002 34.1 15.3002 34.7 15.3002 35.4C15.3002 37.6 17.1002 39.3 19.2002 39.3C21.4002 39.3 23.1002 37.5 23.1002 35.4C23.1002 34.7 23.7002 34.1 24.4002 34.1C25.1002 34.1 25.7002 34.7 25.7002 35.4C25.8002 39.1 22.9002 42 19.3002 42Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3 7.9C18.6 7.9 18 7.3 18 6.6V1.3C18 0.6 18.6 0 19.3 0C20 0 20.6 0.6 20.6 1.3V6.6C20.6 7.3 20 7.9 19.3 7.9Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.50039 20.3C9.40039 20.3 10.1004 19.6 10.1004 18.7C10.1004 17.8 9.40039 17.1 8.50039 17.1C7.60039 17.1 6.90039 17.8 6.90039 18.7C6.90039 19.5 7.60039 20.3 8.50039 20.3Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6998 31.3C33.0998 29.1 31.4998 25.8 31.4998 22.3V17.8C31.4998 11.3 26.5998 5.60003 20.0998 5.20003C15.5998 4.90003 11.5998 7.00003 9.29978 10.4L9.19978 10.5C8.99978 10.7 8.79978 11 8.79978 11.4C8.79978 12.1 9.39978 12.7 10.0998 12.7C10.5998 12.7 11.0998 12.3 11.3998 11.9C13.2998 9.30003 16.3998 7.60003 19.8998 7.80003C24.9998 8.10003 28.8998 12.6 28.8998 17.8V22.3C28.8998 26.5 30.7998 30.5 33.9998 33.3C34.0998 33.3 34.1998 33.5 34.1998 33.6C34.1998 33.8 33.9998 34 33.7998 34H4.79978C4.59978 34 4.39978 33.8 4.39978 33.6C4.39978 33.4 4.49978 33.3 4.59978 33.3C6.89978 31.4 8.39978 28.9 9.19978 26.1C9.29978 25.9 9.29978 25.8 9.29978 25.6C9.29978 24.9 8.69978 24.3 7.99978 24.3C7.39978 24.3 6.79978 24.7 6.69978 25.3V25.4C6.09978 27.7 4.79978 29.8 2.89978 31.4C1.99978 32.2 1.59978 33.5 1.99978 34.8C2.39978 36 3.69978 36.8 4.99978 36.8C10.0998 36.8 28.3998 36.8 33.5998 36.8C34.8998 36.8 36.1998 36.1 36.5998 34.8C36.9998 33.5 36.5998 32.1 35.6998 31.3Z"
});

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e9806d01.svg";
export { ForwardRef as ReactComponent };